/* RUVEE low stock note. Shows a delivery estimate under the buy buttons when the selected size has little stock. */
(function () {
  var data = document.getElementById('rvm-stock-data');
  if (!data) return;
  var low;
  try { low = JSON.parse(data.textContent); } catch (e) { return; }
  var text = data.getAttribute('data-text') || 'Low stock. Ships in 5 to 7 days.';

  function wrap() { return document.querySelector('[data-ai-cart]'); }
  function note() {
    var n = document.getElementById('rvm-stock-note');
    if (n) return n;
    var w = wrap();
    if (!w) return null;
    n = document.createElement('p');
    n.id = 'rvm-stock-note';
    n.setAttribute('role', 'status');
    n.style.cssText = 'margin:10px 0 0;font-size:13px;letter-spacing:.02em;color:#6b5f52';
    n.hidden = true;
    w.insertAdjacentElement('afterend', n);
    return n;
  }
  function update() {
    var w = wrap();
    if (!w) return;
    var input = w.querySelector('input[name=id]');
    var n = note();
    if (!input || !n) return;
    var isLow = !!low[input.value];
    n.textContent = isLow ? text : '';
    n.hidden = !isLow;
  }
  ['change', 'variant:update', 'popstate'].forEach(function (type) {
    document.addEventListener(type, function () { setTimeout(update, 80); });
  });
  document.addEventListener('DOMContentLoaded', function () { update(); setTimeout(update, 600); });
  if (document.readyState !== 'loading') { update(); setTimeout(update, 600); }
})();
